const modalCancel = document.querySelector('.cancelOrder--modal');
const modalbtnCancel = document.querySelector('.cancelOrder--modal .cancelOrder-cancel');
const modalbtnAcceptCancel = document.querySelector('.cancelOrder--modal .cancelOrder-true');
const modalbtnAcceptCanceltext = document.querySelector('.cancelOrder--modal .cancelOrder-true p');
const modalbtnBack = document.querySelector('.cancelOrder--modal .cancelOrder-goBack');
const modalTitle = document.querySelector('.cancelOrder--modal .cancelOrder--title');
const modalSubTitle = document.querySelector('.cancelOrder--modal .cancelOrder--subtitle');
const modalDescription = document.querySelector('.cancelOrder--modal .cancelOrder--description');
const imgeOrderError = document.querySelector('.cancelOrder--modal .error--cancelOrder');
const imgeOrderSuccess = document.querySelector('.cancelOrder--modal .success--cancelOrder');
const loaderSpinner = document.querySelector('.cancelOrder--modal .spinner');


function opencancelModal(orderID) {

    modalbtnAcceptCanceltext.style.display = "block";
    loaderSpinner.classList.remove('spinner--show');

    modalbtnAcceptCancel.setAttribute("orderID", orderID);

    modalCancel.classList.add('cancelOrder--modal--show');


    modalbtnCancel.addEventListener("click", function(){

        modalCancel.classList.remove('cancelOrder--modal--show');
        imgeOrderError.classList.remove('cancelOrder--modal--show');
        modalSubTitle.classList.remove('cancelOrder--modal--show');
        modalTitle.innerHTML = "Are you sure you want to cancel this order?";
        modalDescription.innerHTML = "Once you cancel your order you will not be charged and the order will not ship. Credit card authorizations may take up to 10 days to reflect on your bank statement.";
        modalbtnCancel.classList.remove('cancelOrder--modal--hidden');
        modalbtnAcceptCancel.classList.remove('cancelOrder--modal--hidden');
        modalbtnBack.classList.remove('cancelOrder--modal--show');
        modalCancel.classList.remove('cancelOrder--modal--error');
        modalCancel.classList.remove('cancelOrder--modal--success');
        modalDescription.classList.remove('cancelOrder--modal--hidden');
        imgeOrderSuccess.classList.remove('cancelOrder--modal--show');
    });

    modalbtnBack.addEventListener("click", function(){

        modalCancel.classList.remove('cancelOrder--modal--show');
        imgeOrderError.classList.remove('cancelOrder--modal--show');
        modalSubTitle.classList.remove('cancelOrder--modal--show');
        modalTitle.innerHTML = "Are you sure you want to cancel this order?";
        modalDescription.innerHTML = "Once you cancel your order you will not be charged and the order will not ship. Credit card authorizations may take up to 10 days to reflect on your bank statement.";
        modalbtnCancel.classList.remove('cancelOrder--modal--hidden');
        modalbtnAcceptCancel.classList.remove('cancelOrder--modal--hidden');
        modalbtnBack.classList.remove('cancelOrder--modal--show');
        modalCancel.classList.remove('cancelOrder--modal--error');
        modalCancel.classList.remove('cancelOrder--modal--success');
        modalDescription.classList.remove('cancelOrder--modal--hidden');
        imgeOrderSuccess.classList.remove('cancelOrder--modal--show');
        window.location.reload();
    });
    
}


async function btnCancelOrders(customerID, customerEmail) {

    let orderID = modalbtnAcceptCancel.getAttribute('orderid');

    const response = await postData({
        "action": "cancel-web-order",
        "order_id": orderID,
        "customer_id": customerID,
        "email": customerEmail
     });

    console.log(response);

    if (response.data.body.status == "1") {
        modalTitle.innerHTML = "Your order has been succesfully canceled!  You will not be charged.";
        modalDescription.classList.add('cancelOrder--modal--hidden');
        imgeOrderError.classList.remove('cancelOrder--modal--show');
        modalSubTitle.classList.remove('cancelOrder--modal--show');
        modalbtnCancel.classList.add('cancelOrder--modal--hidden');
        modalbtnAcceptCancel.classList.add('cancelOrder--modal--hidden');
        modalbtnBack.classList.add('cancelOrder--modal--show');
        modalCancel.classList.add('cancelOrder--modal--success');
        imgeOrderSuccess.classList.add('cancelOrder--modal--show');
    
    } else {
        modalTitle.innerHTML = "PLEASE TRY AGAIN";
        modalDescription.innerHTML = "We coudn’t cancel the order. Please reload the page and try again.  Orders that have already been sent to our warehouse for fulfillment cannot be cancelled.";
        imgeOrderError.classList.add('cancelOrder--modal--show');
        modalSubTitle.classList.add('cancelOrder--modal--show');
        modalbtnCancel.classList.add('cancelOrder--modal--hidden');
        modalbtnAcceptCancel.classList.add('cancelOrder--modal--hidden');
        modalbtnBack.classList.add('cancelOrder--modal--show');
        modalCancel.classList.add('cancelOrder--modal--error');
    }



}

async function postData(data) {
  //  console.log("Cancel Order DATA", data);
    modalbtnAcceptCanceltext.style.display = "none";
    loaderSpinner.classList.add('spinner--show');
    return new Promise(function (resolve) {
        fetch('https://n3x13anhnc.execute-api.us-east-1.amazonaws.com/fulfill-order/', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(res => res.json()).then(data => resolve({success: true, data: data})).catch(err => resolve({success: false, data: err }));
    });
}

var elementExists = document.querySelector(".btn-cancel");

